import { TextField, Autocomplete } from "@mui/material";
import type { SyntheticEvent } from "react";
import type { KeySelectChangedHandler, KeyValueOption } from "../../../types";

const inputStatus: KeyValueOption[] = [
  { key: 0, value: "未実施" },
  { key: 1, value: "実施済" },
];

type SsRecoveryCheckSelectProps = {
  recoveryStatus?: number | string | boolean | null;
  changedValue: KeySelectChangedHandler;
};

export default function SsRecoveryCheckSelect({
  recoveryStatus,
  changedValue,
}: SsRecoveryCheckSelectProps) {
  const handleChange = (
    _event: SyntheticEvent,
    newValues: KeyValueOption | null,
  ) => {
    changedValue(newValues ? newValues.key : null);
  };

  const numericStatus =
    recoveryStatus === true
      ? 1
      : recoveryStatus === false
        ? 0
        : typeof recoveryStatus === "string"
          ? Number(recoveryStatus)
          : recoveryStatus;

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={inputStatus}
      getOptionLabel={(sale) => sale.value}
      isOptionEqualToValue={(option, value) => option.key === value.key}
      value={
        inputStatus.find((status) => status.key === numericStatus) || null
      }
      renderInput={(params) => (
        <TextField {...params} name="recoveryStatusSelect" placeholder="未入力" />
      )}
      onChange={handleChange}
    />
  );
}
